import { render, staticRenderFns } from "./AssetsLibContent.vue?vue&type=template&id=6b459f49"
import script from "./AssetsLibContent.vue?vue&type=script&lang=js"
export * from "./AssetsLibContent.vue?vue&type=script&lang=js"
import style0 from "./AssetsLibContent.vue?vue&type=style&index=0&id=6b459f49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports